__turbopack_context__.v({
  "allTerms": "glossary-module-scss-module__NU3cJa__allTerms",
  "bgGrey": "glossary-module-scss-module__NU3cJa__bgGrey",
  "card": "glossary-module-scss-module__NU3cJa__card",
  "cardGrid": "glossary-module-scss-module__NU3cJa__cardGrid",
  "cardGridItem": "glossary-module-scss-module__NU3cJa__cardGridItem",
  "latestTerms": "glossary-module-scss-module__NU3cJa__latestTerms",
  "latestTermsWrapper": "glossary-module-scss-module__NU3cJa__latestTermsWrapper",
  "lcResourcesContainer": "glossary-module-scss-module__NU3cJa__lcResourcesContainer",
  "main": "glossary-module-scss-module__NU3cJa__main",
  "postBody": "glossary-module-scss-module__NU3cJa__postBody",
  "prequal": "glossary-module-scss-module__NU3cJa__prequal",
  "section": "glossary-module-scss-module__NU3cJa__section",
  "subTitle": "glossary-module-scss-module__NU3cJa__subTitle",
  "termsOfTheDay": "glossary-module-scss-module__NU3cJa__termsOfTheDay",
  "termsOfTheDayWrapper": "glossary-module-scss-module__NU3cJa__termsOfTheDayWrapper",
  "title": "glossary-module-scss-module__NU3cJa__title",
});
